module.exports = __webpack_public_path__ + "img/0S6A0179.a3451209.jpg";